import React from 'react';
import {
  CustomInputContainer,
  CustomInputLabel,
  Item,
  Items,
  ItemContent,
} from './CustomInputs.styles';
import { GamifyIcon } from 'application/components/GamifyIcon';
import { useTheme } from '@mui/material/styles';

interface Props {
  label: string;
  selectedItem: any;
  items: { label: string; value: any; icon?: string }[];
  onSelect: (
    newSelectedItem: {
      label: string;
      value: any;
      icon?: string;
    } | null
  ) => void;
  numColumns: number;
  allowDeselect?: boolean;
}

const ItemSelectInput: React.FC<Props> = ({
  label,
  items,
  onSelect,
  selectedItem,
  numColumns,
  allowDeselect = false,
}) => {
  const theme = useTheme();
  // Function to get the appropriate icon based on the item value
  const getIcon = (value: any, explicitIcon?: string): string | undefined => {
    if (explicitIcon) return explicitIcon;

    switch (value) {
      case 'regular':
        return 'allPlay';
      case 'bracket_manual':
        return 'brackets';
      case 'bracket_seed':
        return 'seed';
      case 'percent_to_goal':
        return 'percentageToGoal';
      default:
        return undefined;
    }
  };

  const handleItemClick = (item: {
    label: string;
    value: any;
    icon?: string;
  }) => {
    const isCurrentlySelected = selectedItem === item.value;

    if (allowDeselect && isCurrentlySelected) {
      // Deselect the item by passing null
      onSelect(null);
    } else {
      // Select the item normally
      onSelect(item);
    }
  };

  return (
    <CustomInputContainer>
      <CustomInputLabel theme={theme as any}>{label}</CustomInputLabel>
      <Items numColumns={numColumns}>
        {items.map((item, index) => {
          const isSelected = selectedItem === item.value;
          const iconName = getIcon(item.value, item.icon);

          return (
            <Item
              key={index}
              onClick={() => handleItemClick(item)}
              isSelected={isSelected}
              theme={theme as any}
            >
              <ItemContent theme={theme as any}>
                {iconName && (
                  <GamifyIcon
                    icon={iconName}
                    color={
                      isSelected
                        ? theme.custom?.primary || '#FF6A00'
                        : theme.custom?.text || '#222428'
                    }
                    width={20}
                    height={20}
                  />
                )}
                {item.label}
              </ItemContent>
            </Item>
          );
        })}
      </Items>
    </CustomInputContainer>
  );
};

export default ItemSelectInput;
